import { Component, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import {
    ActivatedRoute,
    Router,
    Event,
    NavigationStart,
    Params,
    NavigationEnd
} from "@angular/router";
import {
    TravelProductService,
    TravelPackage,
    CreateBookingsOption,
    FareTypeChangedEvent,
    ProductType
} from "../../shared/services/travel-product.service";
import {
    ActionUpdaterService,
    ApiError
} from "../../shared/services/action-updater.service";
import { Booking, Totals } from "../../shared/models/booking.model";
import { BookingService } from "../../shared/services/booking.service";
import { ProductTypeUrl } from "app/shared/models/enums/ProductTypeUrl.enum";
import { LocalStorageService } from "app/shared/services/local-storage.service";
import { GxConstants } from "app/shared/constants/gx.constants";
import { GxUtilsService } from "../../shared/services/gx-utils.service";
import { InitialDataService } from "../../initial-data.service";
import { ProductUrl } from '../../shared/models/availability.model';
import { v } from "@angular/core/src/render3";
import { BookingTotalComponent } from "../product-passenger-details/booking-total/booking-total.component";

@Component({
    selector: 'gaweb-product-payment',
    templateUrl: './product-payment.component.html',
    styles: []
})
export class ProductPaymentComponent implements OnInit {
    @ViewChild(BookingTotalComponent) bookingTotalComponent: BookingTotalComponent;
    ProductTypeUrl = ProductTypeUrl;
    parentBookingGuid: string;
    bookings: Array<Booking>;
    productReference: string;
    productType: ProductTypeUrl;
    productUrl: ProductUrl;
    productTypeName: string;
    productName: string;
    loadingData: boolean;
    transactionNumber: string;
    paymentContext = GxConstants.PAYMENT_CONTEXT.CONFIRMATION;
    totals: Totals;
    passDisplayDescription: string[];
    subDescriptions: string[];
    addonMode: boolean = false;
    packageName: string;
    constructor(
        public travelPackageService: TravelProductService,
        private router: Router,
        private bookingService: BookingService,
        private activatedRoute: ActivatedRoute,
        private actionUpdaterService: ActionUpdaterService,
        private localStorageService: LocalStorageService,
        private initialDataService: InitialDataService,
        private gxUtils: GxUtilsService
    ) {}

    ngOnInit() {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.parentBookingGuid = params['bookingGuid'];
            this.productReference = params['product-reference'];

            this.productUrl = new ProductUrl(
                this.router.url,
                this.initialDataService
            );
            const productTypeStr = params['product-type'];
            this.productType = this.productUrl.ProductTypeUrl;
            this.productTypeName = this.productUrl.ProductName;
            if (
                this.productType === ProductTypeUrl.travelPasses ||
                this.productType === ProductTypeUrl.expressBooking
            ) {
                this.bookings = this.travelPackageService.bookings = [
                    this.localStorageService.getOnlineBooking()
                ];
                this.parentBookingGuid = this.bookings[0].BookingGuid;
                this.bookingService
                    .getBookings(this.parentBookingGuid)
                    .subscribe(bookings => {
                        this.bookings = bookings;
                        this.localStorageService.saveOnlineBooking(this.bookings[0]);
                        if (
                            !this.bookings[0] &&
                            this.productType === ProductTypeUrl.travelPasses
                        ) {
                            window.location.href = this.initialDataService.travelPassesParentFolderUrl;
                            return;
                        } else if (
                            !this.bookings[0] &&
                            this.productType === ProductTypeUrl.expressBooking
                        ) {
                            window.location.href = this.initialDataService.makeABookingUrl;
                            return;
                        }

                        this.totals = this.localStorageService.getCart();
                        this.parentBookingGuid = this.bookings[0].BookingGuid;
                        if (this.productType === ProductTypeUrl.travelPasses) {
                                if (this.bookings[0].Pass == null) {
                                    // tslint:disable-next-line:max-line-length
                                    this.passDisplayDescription = [
                                        this.bookings[0].Package.Name
                                    ];
                                    this.productName = this.passDisplayDescription[0];
                                    this.packageName = this.productName;
                                    this.subDescriptions = [
                                        this.bookings[0].Package.FareTypes[0].Farebasis
                                            .DisplayDescription
                                    ];
                                } else {
                                    this.passDisplayDescription = [
                                        this.bookings[0].Pass.Name
                                    ];
                                    this.productName = this.passDisplayDescription[0];
                                    this.packageName = this.productName;
                                    this.subDescriptions = [
                                        this.bookings[0].Pass.FareTypes.find(f => f.Farebasis.FarebasisCode === this.bookings[0].FareBasis[0].FarebasisCode).Farebasis.DisplayDescription
                                    ];
                                }
                            }
                            this.onPromoCodeChange2();
                    });
            } else if (this.productType === ProductTypeUrl.manageBooking) {
                this.bookings = this.travelPackageService.bookings = [
                    this.localStorageService.getOnlineBooking()
                ];
                this.totals = this.localStorageService.getCart();

                this.parentBookingGuid = this.bookings[0].BookingGuid;
                if (this.bookings[0].Pass) {
                    // tslint:disable-next-line:max-line-length
                    this.passDisplayDescription = [this.bookings[0].Pass.Name];
                    this.productName = this.passDisplayDescription[0];
                    this.packageName = this.totals.PaymentItems[0].Items[0].Name;
                    if(this.bookings[0].Pass.FareTypes.length > 0){
                        this.subDescriptions = [
                            this.bookings[0].Pass.FareTypes[0].Farebasis
                                .DisplayDescription
                        ];
                    }
                }
            } else {
                if (!this.travelPackageService.currentProduct) {
                    this.loadingData = true;
                    this.productReference = this.activatedRoute.snapshot.params[
                        'product-reference'
                    ];
                    let getProductfunc;
                    switch (this.productType) {
                        case ProductTypeUrl.accommodation:
                        case ProductTypeUrl.experience:
                            getProductfunc = this.travelPackageService
                                .getTourExperience;
                            break;
                        case ProductTypeUrl.package:
                            getProductfunc = this.travelPackageService
                                .getPackage;
                            break;
                        default:
                    }
                    getProductfunc
                        .call(this.travelPackageService, this.productReference)
                        .subscribe(travelProduct => {
                            this.loadingData = false;
                            this.productName = travelProduct.title;
                            this.packageName = this.productName;
                            this.travelPackageService.currentProduct = travelProduct;
                            this.onPromoCodeChange2();
                        }, this.actionUpdaterService.onError);
                } else {
                    this.productName = this.travelPackageService.currentProduct.title;
                    this.packageName = this.productName;
                }
            }

            if (!this.travelPackageService.bookings) {
                this.loadingData = true;
                this.bookingService
                    .getBookings(this.parentBookingGuid)
                    .subscribe((bookings: Array<Booking>) => {
                        this.checkIfBookingsTicketed(bookings);
                        this.allocateVisaPromos(bookings);
                        this.loadingData = false;
                        this.updateBookings(bookings);
                        this.setLocalFieldsOffBooking();
                        this.onPromoCodeChange2();
                    }, this.actionUpdaterService.onError);
            } else {
                this.bookings = this.travelPackageService.bookings;
                this.checkIfBookingsTicketed(
                    this.travelPackageService.bookings
                );
                this.allocateVisaPromos(this.bookings);
                this.setLocalFieldsOffBooking();
                this.onPromoCodeChange2();
    }
        });
    }

    private getOriginalAmount() {
        let originalAmount = 0;
        switch (this.productType) {
            case ProductTypeUrl.accommodation:
            case ProductTypeUrl.experience:
                this.bookings[0].Tours.forEach((t) => {
                    originalAmount = originalAmount + t.SelectedCurrencyAmount;
                });
                break;
            case ProductTypeUrl.package:
            default:
                this.bookings.forEach((b) => {
                    originalAmount = originalAmount + b.Package.FareTypes[0].SalePrice;
                });
                break;
        }

        return (Math.round(originalAmount * 100) / 100);
    }

    onPromoCodeChange2() {
        var promo = this.localStorageService.hasPromoApplied();
        if(!!promo && promo.length > 0){
            let originalAmount = this.getOriginalAmount();
            this.bookingTotalComponent.setPromo(!!promo, promo, originalAmount, true);
        }
    }

    allocateVisaPromos(bookings: Array<Booking>) {
        if(bookings){
            bookings.forEach((b) => {
                if(b.Passengers){
                    if(!b.Passengers[0].VisaPromoCode || b.Passengers[0].VisaPromoCode.length == 0){
                        this.travelPackageService.allocateVisaNumber(b.BookingNumber, b.Passengers[0].VisaNumber).subscribe((res) => b.Passengers[0].VisaPromoCode = res);
                    }
                }
            })
        }
    }

    checkIfBookingsTicketed(bookings: Array<Booking>) {
        if (
            bookings[0] &&
            bookings[0].TicketUrl &&
            this.productType !== ProductTypeUrl.manageBooking
        ) {
            window.location.href = '/';
            throw new Error('Booking Already Ticketed');
        }
    }

    setLocalFieldsOffBooking() {
        this.transactionNumber = this.bookings[0].TransactionNumber;
    }

    onTotalsUpdating(totals: Totals) {
        this.totals = totals;
    }

    updateBookings(bookings: Array<Booking>) {
        this.bookings = bookings;
        this.travelPackageService.bookings = bookings;
    }

    goBack() {
        // window.history.back();
        if (
            this.productType === ProductTypeUrl.travelPasses ||
            this.productType === ProductTypeUrl.expressBooking ||
            this.productType === ProductTypeUrl.manageBooking
        ) {
            window.history.back();
        } else {
        let foundTravel = false;
        this.bookings.forEach((booking: Booking) => {
            if (booking.Sectors.length > 0) {
                foundTravel = true;
            }
        });

        const productRef = window.location.pathname.split("/")[1];
        const categoryReference = this.activatedRoute.snapshot.params[
            'category-reference'
        ];
        const productReference = this.activatedRoute.snapshot.params[
            'product-reference'
        ];

        this.router.navigate([`/${productRef}/${categoryReference}/${productReference}/book-now/${this.parentBookingGuid}`]);


        // if (foundTravel) {
        //     history.go(-2);// this.router.navigate([`${this.productUrl.ProductPaymentUrl}/${this.productReference}/seat-confirmation/${this.parentBookingGuid}`]);
        // } else {
        //     history.go(-2);
        //     //this.router.navigate([`${this.productUrl.ProductPaymentUrl}/${this.productReference}/book-now/${this.parentBookingGuid}`]);
        // }
    }
}
}



// WEBPACK FOOTER //
// ./src/app/travel-products/product-payment/product-payment.component.ts